// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import { CurrencyProvider } from './contexts/CurrencyContext';
import HomePage from './features/home/HomePage';
import MeetingPage from './features/meetings/MeetingPage';
import LiveMeetingPage from './features/live-meetings/LiveMeetingPage';
import DocumentPage from './features/documents/DocumentPage';
import SharedMeetingPage from './features/shared/SharedMeetingPage';
import MethodologyPage from './features/methodology/MethodologyPage';
import NotFoundPage from './features/error/NotFoundPage';

function App() {
  return (
    <ErrorBoundary>
      <CurrencyProvider>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/meetings" element={<MeetingPage />} />
            <Route path="/live-meetings" element={<LiveMeetingPage />} />
            <Route path="/shared" element={<SharedMeetingPage />} />
            <Route path="/documents" element={<DocumentPage />} />
            <Route path="/methodology" element={<MethodologyPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Router>
      </CurrencyProvider>
    </ErrorBoundary>
  );
}

export default App;
